// trackingIds.js
// One dedupe key generator for pixel events.
//
// Meta matches its browser copy of an event against the server's copy on
// `event_id` AND `event_name` together. An event sent with an empty event_id can
// therefore never be deduplicated, and the same sale is counted twice.
//
// Every funnel that mints one had its own inline copy of this function. They have
// drifted before, so the surfaces that need a dedupe key now share this one.

/**
 * A UUID for one event.
 *
 * crypto.randomUUID needs a secure context, which a plain-http page does not have,
 * so the two fallbacks are load-bearing rather than defensive padding.
 */
export const newEventId = () => {
    try {
        if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
            return crypto.randomUUID();
        }
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            const r = (Math.random() * 16) | 0;
            const v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    } catch (error) {
        return `evt_${Date.now()}_${Math.random().toString(16).slice(2)}`;
    }
};

export default newEventId;
